import { render, staticRenderFns } from "./AuthReset.vue?vue&type=template&id=e4076f06&scoped=true"
import script from "./AuthReset.vue?vue&type=script&lang=js"
export * from "./AuthReset.vue?vue&type=script&lang=js"
import style0 from "./AuthReset.vue?vue&type=style&index=0&id=e4076f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4076f06",
  null
  
)

export default component.exports